import { render } from "./aboutModal.vue?vue&type=template&id=0fcf0617&scoped=true"
import script from "./aboutModal.vue?vue&type=script&lang=js"
export * from "./aboutModal.vue?vue&type=script&lang=js"

import "./aboutModal.vue?vue&type=style&index=0&id=0fcf0617&scoped=true&lang=css"
import "./aboutModal.vue?vue&type=style&index=1&id=0fcf0617&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcf0617"]])

export default __exports__